import { timestampDate } from '@bufbuild/protobuf/wkt'

import { LEMA_USER_ID } from '@/const/contact'

import { ONE_YEAR_AGO } from '@/lib/date/date'
import { useLastIrqChange } from '@/lib/risk/last-irq-change.hook'

export const useIsIrqCompleted = (companyId: string, engagementModeEnabled: boolean) => {
  const { lastIRQChange } = useLastIrqChange(companyId)

  // In case the last IRQ update was on an engagement, the user needs to validate the company’s inherent risk and proceed to assessment.
  if (engagementModeEnabled && lastIRQChange.engagementId) {
    return false
  }

  if (!lastIRQChange.time || lastIRQChange.userId === LEMA_USER_ID) {
    return false
  }

  // If the last IRQ update was updated more than one year ago, we consider it as not completed
  return lastIRQChange.time ? timestampDate(lastIRQChange.time) > ONE_YEAR_AGO : false
}
